import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import userTypeGroupsServices from '@src/services/userTypeGroups.services';

export const getUserTypeGroupsById = createAsyncThunk(
  'admin/getUserTypeGroupsById',
  async ({ id }, { rejectWithValue }) => {
    try {
      return await userTypeGroupsServices.getUserTypeGroupsById({ id });
    } catch (error) {
      return rejectWithValue(error?.data);
    }
  },
);

export const addUserTypeGroups = createAsyncThunk(
  'admin/addUserTypeGroups',
  async (data, { dispatch, rejectWithValue }) => {
    try {
      const response = await userTypeGroupsServices.addUserTypeGroups(data);
      return response;
    } catch (error) {
      return rejectWithValue(error?.data);
    }
  },
);

export const deleteUserTypeGroups = createAsyncThunk(
  'admin/deleteUserTypeGroups',
  async (data, { dispatch, rejectWithValue }) => {
    try {
      const response = await userTypeGroupsServices.deleteUserTypeGroups(data);
      return response;
    } catch (error) {
      return rejectWithValue(error?.data);
    }
  },
);

const initialState = {
  userTypeGroupList: [],
  selectedUserType: null,
  selectedMenuType: null,
  addResponse: {},
};

export const userTypeGroupsSlice = createSlice({
  name: 'admin/userTypeGroups',
  initialState,
  reducers: {
    selectedUserTypeList: (state, action) => {
      state.selectedUserType = action.payload;
    },
    selectedMenuList: (state, action) => {
      state.selectedMenuType = action.payload;
    },
    resetResponse: (state) => {
      state.addResponse = {};
    },
    resetUserTypeGroupList: (state) => {
      state.userTypeGroupList = [];
    },
    resetUserType: (state) => {
      state.selectedUserType = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getUserTypeGroupsById.fulfilled, (state, action) => {
      state.userTypeGroupList = action.payload.data;
    });
    builder.addCase(addUserTypeGroups.fulfilled, (state, action) => {
      state.addResponse = action.payload;
    });
    builder.addCase(addUserTypeGroups.rejected, (state, action) => {
      state.addResponse = action.payload;
    });
    builder.addCase(deleteUserTypeGroups.fulfilled, (state, action) => {
      state.addResponse = action.payload;
    });
    builder.addCase(deleteUserTypeGroups.rejected, (state, action) => {
      state.addResponse = action.payload;
    });
  },
});

export const {
  selectedUserTypeList,
  selectedMenuList,
  resetResponse,
  resetUserTypeGroupList,
  resetUserType,
} = userTypeGroupsSlice.actions;
